var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarcirclefill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 127.197 127.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 127.295,
    opacity: 0,
    width: 127.197,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.197 63.623C127.197 98.6328 98.6328 127.197 63.5742 127.197C28.5645 127.197 0 98.6328 0 63.623C0 28.5645 28.5645 0 63.5742 0C98.6328 0 127.197 28.5645 127.197 63.623ZM60.2051 28.125L53.0273 50.4883L29.6387 50.3418C25.4395 50.293 24.3652 54.7852 27.4902 57.0312L46.5332 70.6543L39.1602 92.8711C37.8418 96.8262 41.4062 99.4141 44.6777 96.9238L63.5742 83.1055L82.4707 96.9238C85.8398 99.4141 89.3555 96.8262 88.0371 92.8711L80.6641 70.6543L99.707 56.9824C102.686 54.8828 101.807 50.293 97.5098 50.3418L74.1211 50.4883L66.9922 28.125C65.7715 24.3164 61.377 24.3164 60.2051 28.125Z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarcirclefill);
export default __webpack_public_path__ + "static/media/star.circle.fill.426da46e3812298503e0eee9c5b627e0.svg";
export { ForwardRef as ReactComponent };